// extracted by mini-css-extract-plugin
export default {"title":"ItemEditView_title__XtVR-","espacamento":"ItemEditView_espacamento__6NcAH","espacamentoBotoes":"ItemEditView_espacamentoBotoes__n5zCu"};